import { Box, CircularProgress, LinearProgress } from '@mui/material';
import React, { useState } from 'react'
import Dropzone from 'react-dropzone';
import { IoCloudUploadOutline } from "react-icons/io5";
import { PiFiles } from "react-icons/pi";
import { uploadImageToServer } from '../api/rc_admission_form';
import { uploadFileToServer } from '../utils/helper/rc_form_helper';

const UploadDropzone = ({ setAttachments, onComplete, attachments, setShowDialog }) => {
	const [isUploading, setIsUploading] = useState(false);
	const [uploadProgress, setUploadProgress] = useState(0);

	const simulateUploadProgress = () => {
		setUploadProgress(0);

		const interval = setInterval(() => {
			setUploadProgress((prev) => {
				if (prev >= 95) {
					clearInterval(interval);
					return prev;
				}
				return prev + 10;
			});
		}, 500);

		return interval;
	}

	return (
		<Dropzone
			multiple={true}
			maxFiles={5}
			maxSize={5242880}
			accept={{
				'image/jpeg': [],
				'image/png': [],
				'application/pdf': [],
				'application/vnd.ms-excel': [],
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': []
			}}
			onDrop={async (acceptedFiles) => {
				setIsUploading(true);
				const progressInterval = simulateUploadProgress();

				if(acceptedFiles.length + attachments.length > 5) {
					alert("You can only upload up to 5 files in total");
					setIsUploading(false);
					clearInterval(progressInterval);
					setShowDialog(false);
					return;
				}

				const attachmentsArr = [];
				acceptedFiles.map((image) => {
					let imgObj = {
						prefix: "1/admission/documents",
						filename: image.name
					}
					attachmentsArr.push(imgObj);
				});

				let transformAttachments = { payload: attachmentsArr }

				const res = await uploadImageToServer(transformAttachments);
				const convertedAttachments = [];
				if(res) {
					Object.keys(res).map(async (key, index) => {
						const attachmentArr = res[key];
						const uploadUrl = attachmentArr[0].uploadUrl;
						const file = acceptedFiles[index];

						await uploadFileToServer(uploadUrl, file)
					});

					Object.keys(res).forEach(key => {
						const attachmentArr = res[key];
						attachmentArr.forEach(attachment => {
							const convertedFiles = {
								attachment_url_s3: attachment?.downloadUrl,
								attachment_name: attachment?.filePath.split('/').pop()
							}

							convertedAttachments.push(convertedFiles);
						});
					})
				} else {
					alert("Upload failed. You can only attach up to 5 files.")
				}

				clearInterval(progressInterval);
				setUploadProgress(100);

				setAttachments(convertedAttachments);
				onComplete();
			}}
		>
			{({ getRootProps, getInputProps, acceptedFiles }) => (
				<div {...getRootProps()} className="dropzone">
					<div className="dropzone-inner">
						<label htmlFor="dropzone-file" className="dropzone-label">
							<div className="dropzone-content">
								<IoCloudUploadOutline className="dropzone-icon" />
								<p className="dropzone-text-primary">
									<span>Click to upload</span> or drag and drop
								</p>
								<p className="dropzone-text-secondary">JPG, PNG, JPEG, PDF, XLS</p>
							</div>

							{acceptedFiles && acceptedFiles.length > 0 ? (
								<div className='file-preview-container'>
									{ acceptedFiles.map((file, i) => (
										<div className="file-preview" key={i}>
											<div className="file-preview-icon">
												<PiFiles className="file-preview-icon-inner" />
											</div>
											<div className="file-preview-text">
												{file.name}
											</div>
										</div>
									))}
								</div>
							) : null}

							{isUploading ? (
								<div className="upload-progress-container">
									<Box sx={{ width: '100%' }}>
										<LinearProgress
											variant='determinate' value={uploadProgress}
											className={`custom-progress-bar ${uploadProgress === 100 ? 'upload-progress-bar-indicator' : ''}`}
										/>
									</Box>
									{uploadProgress === 100 ? (
										<div className="redirect-message">
											<CircularProgress className='loader' />
											A moment...
										</div>
									) : null}
								</div>
							) : null}
							<input {...getInputProps()} type="file" id="dropzone-file" className="hidden" />
						</label>
					</div>
				</div>
			)}
		</Dropzone>
	)
}

export default UploadDropzone